<template>
  <div
    class="subtitle-panel"
    @keydown.stop
  >
    <div class="tabs">
      <Tabs />
    </div>
    <div class="item-wrapper">
      <SubtitlePosition />
    </div>
    <div class="item-wrapper">
      <FontFamily />
    </div>
    <div class="item-wrapper">
      <FontSizeColor />
    </div>
    <div class="item-wrapper">
      <FontStyle />
    </div>
    <div class="item-wrapper">
      <TextAlign />
    </div>
    <div class="item-wrapper">
      <TextOutline></TextOutline>
    </div>
    <div class="item-wrapper">
      <ShadowColor />
    </div>
    <div class="item-wrapper">
      <SliderItem
        name="x"
        :title="'X偏移'"
        @updateValueByDrag="updateShadowX"
        @updateValueByInput="updateSlideValue"
        ref="shadowX"
      />
    </div>
    <div class="item-wrapper">
      <SliderItem
        name="y"
        :title="'Y偏移'"
        @updateValueByDrag="updateShadowY"
        @updateValueByInput="updateSlideValue"
        ref="shadowY"
      />
    </div>
    <div class="item-wrapper">
      <SliderItem
        name="blur"
        :title="'模糊'"
        :startValue="0"
        :totalValue="50"
        @updateValueByDrag="updateShadowBlur"
        @updateValueByInput="updateSlideValue"
        ref="shadowBlur"
      />
    </div>

    <div class="item-wrapper short-btn-wrapper">
      <div
        class="reset short-btn"
        @click="reset()"
      >重置设置</div>
      <div
        class="remove short-btn"
        @click="remove()"
      >删除字幕</div>
    </div>
    <div class="item-wrapper">
      <div
        class="apply-all"
        @click="applyAll"
      >应用到所有字幕</div>
    </div>

    <div
      class="mask"
      v-if="!subtitle"
    ></div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import SliderItem from './subtitlePanel/sliderItem';
import Tabs from './subtitlePanel/tabs';
import SubtitlePosition from './subtitlePanel/subtitlePosition';
import FontFamily from './subtitlePanel/fontFamily';
import FontSizeColor from './subtitlePanel/fontSizeColor';
import FontStyle from './subtitlePanel/fontStyle';
import TextAlign from './subtitlePanel/textAlign';
import ShadowColor from './subtitlePanel/shadowColor';
import TextOutline from './subtitlePanel/textOutline';

export default {
  components: {
    Tabs,
    SubtitlePosition,
    FontFamily,
    FontSizeColor,
    FontStyle,
    TextAlign,
    ShadowColor,
    SliderItem,
    TextOutline
  },
  data () {
    return {
      shadowX: 0,
      shadowY: 0,
      shadowBlur: 0,
      subtitleMemo: null
    }
  },
  computed: {
    ...mapGetters({
      subtitle: 'subtitle/selectSubtitle',
      defaultSubtitle: 'subtitle/defaultSubtitle',
      subtitleIndex: 'subtitle/subIndex',
      subtitles: 'subtitle/subtitles',
      subtitleEditor: 'subtitle/subtitleEditor'
    })
  },
  created () {
    this.$watch(function () {
      if (this.subtitle) {
        return this.subtitle.dropShadow.x;
      }
    }, function (val, oldVal) {
      this.shadowX = val || 0;
      this.$refs.shadowX.num = val || 0;
    });

    this.$watch(function () {
      if (this.subtitle) {
        return this.subtitle.dropShadow.y;
      }
    }, function (val, oldVal) {
      this.shadowY = val || 0;
      this.$refs.shadowY.num = val || 0;
    });

    this.$watch(function () {
      if (this.subtitle) {
        return this.subtitle.dropShadow.blur;
      }
    }, function (val, oldVal) {
      this.shadowBlur = val || 0;
      this.$refs.shadowBlur.num = val || 0;
    });

    eve.on('updateSubtitleUndo', this.updateSubtitleUndo);
  },
  mounted () {
    // this.$refs.SliderItem.updateValue(33);
  },
  beforeDestroy () {
    eve.off('updateSubtitleUndo', this.updateSubtitleUndo);
  },
  methods: {
    updateShadowBase (data, dragType) {
      if (dragType === 'first') {
        this.subtitleMemo = JSON.parse(JSON.stringify(this.subtitle));
      }
      let isLast = dragType === 'last';
      let commitName = isLast ? 'subtitle/updateSubtitleUndo' : 'subtitle/updateSubtitle'
      if (isLast) {
        this.$store.commit(commitName, {
          subtitle: {
            dropShadow: {
              ...data
            }
          },
          subtitleMemo: this.subtitleMemo
        });
      } else {
        this.$store.commit(commitName, {
          subtitle: {
            dropShadow: {
              ...data
            }
          },
        });
      }
    },
    updateSlideValue (val, name) {
      this.$store.commit('subtitle/updateSubtitleUndo', {
        subtitle: {
          dropShadow: {
            [name]: val
          }
        },
      });
    },
    updateShadowX (val, dragType) {
      this.updateShadowBase({ x: val }, dragType);
    },
    updateShadowY (val, dragType) {
      this.updateShadowBase({ y: val }, dragType);
    },
    updateShadowBlur (val, dragType) {
      this.updateShadowBase({ blur: val }, dragType);
    },
    remove () {
      this.$bus.emit('insert_subtitle_undo', {
        type: 'delSubtitles',
        data: {
          data: JSON.stringify(this.subtitle),
          index: this.subtitleIndex
        }
      });
      this.$store.commit('subtitle/delSubtitles');
      this.$bus.emit("subtitle_panel_del");
    },
    reset () {
      let subtitleHeight = 0;
      let subtitleWidth = 0;
      try {
        subtitleHeight = this.subtitle.outward.height;
        subtitleWidth = this.subtitle.outward.width;
      } catch (e) {
        }
      let data = {
        ...this.defaultSubtitle,
        outward: {
          x: (1920 - subtitleWidth ) / 2,
          y: 1080 - 50 - subtitleHeight
        }
      }
      data = JSON.parse(JSON.stringify(data));
      this.$store.commit('subtitle/updateSubtitleUndo', {
        subtitle: data
      });
    },
    applyAll () {
      let subtitleIndex = this.subtitleIndex;
      let prevList = JSON.parse(JSON.stringify(this.subtitles));
      this.subtitles.forEach((v, i) => {
        if (v !== this.subtitle) {
          let subtitleObj = {
            "outward": {
              "x": this.subtitle.outward.x,
              "y": this.subtitle.outward.y,
            },
            "dropShadow": this.subtitle.dropShadow,
            "font": this.subtitle.font
          };
          subtitleObj = JSON.parse(JSON.stringify(subtitleObj));
          this.$store.commit('subtitle/updateSubtitle', {
            subtitle: subtitleObj,
            index: i
          });
        }
      });
      let cur = this.subtitles[subtitleIndex];
      this.$bus.emit('insert_subtitle_undo', {
        type: 'subtitleApplyAll',
        data: {
          reData: prevList,
          data: cur
        }
      })
    },
    updateSubtitleUndo (data) {
      let _data = {
        reData: data.reData,
        reIndex: data.reIndex,
        data: data.data,
        index: data.index == null ? this.subtitleIndex : data.index,
      }
      _data = JSON.parse(JSON.stringify(_data))
      this.$bus.emit('insert_subtitle_undo', {
        type: 'updateSubtitle_time',
        data: _data
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.subtitle-panel {
  position: relative;
  width: 246px;
  height: 100%;
  background: #ffffff;
  box-shadow: 0px 0px 4px 0px rgba(44, 75, 248, 0.2);

  & > .item-wrapper,
  & > .tabs {
    padding: 8px 10px;
  }
}
.reset {
  width: 29px;
  height: 14px;
  font-size: 14px;
  color: #737596;
  cursor: pointer;
}
.apply-all {
  width: 226px;
  height: 32px;
  background: #f2f3f7;
  border: 1px transparent solid;
  border-radius: 4px;
  line-height: 32px;
  margin: auto;
  cursor: pointer;
  color: #474261;
  &:hover {
    color: #5778fb;
    border-color: #5778fb;
    background-color: #fff;
  }
}
.mask {
  position: absolute;
  top: 52px;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(#fff, 0.5);
}
.short-btn-wrapper {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: auto;
  margin-top: 4px;
}
.short-btn {
  cursor: pointer;
  width: 105px;
  height: 30px;
  line-height: 30px;
  background: #ffffff;
  border: 1px solid #d9ddea;
  border-radius: 4px;
  font-size: 12px;
  color: #737596;
  &:hover {
    border-color: #5778fb;
    color: #5778fb;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/subtitle/subtitlePanel.vue